import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { PositionEnum, SdBorderWrapperComponent } from '@seb/web-design-system/core';

import { SdAddressCardComponent } from '../address-card/address-card.component';
import { IAddressCard } from '../address-card/address-card.interface';

@Component({
  selector: 'sd-address-checkout',
  templateUrl: './address-checkout.component.html',
  styleUrls: ['./address-checkout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdAddressCardComponent,
    TranslateModule
  ]
})
export class SdAddressCheckoutComponent {
  positionEnum = PositionEnum;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel: number;

  @Input()
  title: string;

  @Input()
  hasSubContent = false;

  @Input()
  addresses: IAddressCard[];

  @Input()
  pickupRepairChooseAction: string;

  @Input()
  readOnly: boolean;

  @Input()
  inactive: boolean;

  @Output()
  edit = new EventEmitter<{ address: IAddressCard; index: number }>();

  @Output()
  switch = new EventEmitter<{ address: IAddressCard; index: number }>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.readOnly ? 'is-read-only' : '',
      this.inactive ? 'is-inactive' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  editAddress(address: IAddressCard, index?: number) {
    this.edit.emit({ address, index });
  }

  otherAddress(address: IAddressCard, index?: number) {
    this.switch.emit({ address, index });
  }
}
